import React, { useState, useEffect } from 'react';
import { assetAPI } from '../../../services';
import { Package } from 'lucide-react';

const TYPE_LABELS = { laptop:'Laptop', mobile:'Mobile', tablet:'Tablet', monitor:'Monitor', keyboard:'Keyboard', mouse:'Mouse', headset:'Headset', sim_card:'SIM Card', vehicle:'Vehicle', access_card:'Access Card', other:'Other' };
const TYPE_ICONS = { laptop:'💻', mobile:'📱', tablet:'📲', monitor:'🖥️', keyboard:'⌨️', mouse:'🖱️', headset:'🎧', sim_card:'📡', vehicle:'🚗', access_card:'🪪', other:'📦' };

const MyAssetsPage = () => {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    assetAPI.getMyAssets()
      .then(res => setAssets(Array.isArray(res?.data) ? res.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2"><Package className="w-6 h-6 text-blue-600"/>My Assets</h1>
        <p className="text-sm text-gray-500 mt-1">Company assets currently assigned to you</p>
      </div>

      {loading ? <div className="text-center py-12 text-gray-400">Loading...</div>
      : assets.length === 0 ? (
        <div className="flex flex-col items-center py-16 text-gray-400 bg-white rounded-xl border border-gray-200">
          <Package className="w-12 h-12 mb-3 opacity-30"/><p>No assets assigned to you</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {assets.map(a => (
            <div key={a._id} className="bg-white rounded-xl border border-gray-200 p-5 flex items-start gap-4">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center text-2xl flex-shrink-0">{TYPE_ICONS[a.assetType] || '📦'}</div>
              <div className="flex-1">
                <p className="font-semibold text-gray-900">{a.name}</p>
                <p className="text-xs text-gray-500">{TYPE_LABELS[a.assetType] || a.assetType}</p>
                {a.serialNumber && <p className="text-xs text-gray-400 font-mono mt-1">SN: {a.serialNumber}</p>}
                <div className="flex gap-3 mt-2">
                  <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-700">Assigned</span>
                  <span className="text-xs text-gray-400 capitalize">{a.condition} condition</span>
                </div>
                {a.assignedDate && <p className="text-xs text-gray-400 mt-1">Since: {new Date(a.assignedDate).toLocaleDateString('en-IN')}</p>}
                {a.notes && <p className="text-xs text-gray-500 mt-1 italic">{a.notes}</p>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyAssetsPage;
